import { toast } from "react-toastify";
import axiosInstance, { cdnInstance } from "../axiosInterceptor";
export const submitForm = async ({
 data,
 url,
 editingId = null,
 onSuccess,
 onError,
 navigate,
 closeModal,
 validateFields = [],
 validationErrorsSetter,
}) => {
 let hasErrors = false;
 const errors = {};
 validateFields.forEach((field) => {
  if (!data[field.name]) {
   errors[field.name] = field.message || `${field.name} is required`;
   hasErrors = true;
  }
 });

 if (hasErrors) {
  validationErrorsSetter(errors);
  return;
 }

 try {
  let formData = null;
  const isFormDataRequired = Object.values(data).some(
   (value) => value instanceof File
  );

  if (isFormDataRequired) {
   formData = new FormData();
   Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
   });
  }

  let response;
  if (editingId) {
   response = await axiosInstance.put(
    `${url}/${editingId}`,
    isFormDataRequired ? formData : data
   );
  } else {
   response = await axiosInstance.post(
    url,
    isFormDataRequired ? formData : data
   );
  }
  if (response?.status === 200) {
   toast.success(response.data.message);

   if (onSuccess) onSuccess(response);
   if (navigate) navigate();
   if (closeModal) closeModal();
  }
 } catch (error) {
  const errorMessage = error.response?.data?.message || " occurred";
  toast.error(errorMessage);
  if (onError) onError(error);
  return error;
 }
};
export const fetchData = async (
 url,
 requestData,
 setData,
 setTotalCount,
 setCurrentPage,
 setIsLoading,
 setNextPosition
) => {
 setIsLoading && setIsLoading(true);
 try {
  const response = await axiosInstance.get(url, { params: requestData });
  const { data, totalCount ,currentPage,nextSortOrder} = response.data;
  setData(data);
  setTotalCount(totalCount);
  setCurrentPage(currentPage);
  setIsLoading(false);
  setNextPosition(nextSortOrder);
 } catch (error) {
  setIsLoading && setIsLoading(true);
  let message = error?.response?.data?.message;
  toast.error(message);
 }
 finally{
    setIsLoading && setIsLoading(false);
 }
};
export const deleteItem = async (
 url,
 id,
 fetchDataCallback,
 imageUrls = []
) => {
 try {
  const response = await axiosInstance.delete(`${url}/${id}`);
  if (response.status === 200) {
   if (fetchDataCallback) fetchDataCallback();
   if (Array.isArray(imageUrls) && imageUrls.length > 0) {
    await Promise.all(
     imageUrls.map((image) =>
      cdnInstance.delete("/delete", {
       data: { image },
      })
     )
    );
   }

   return response.data;
  } else {
   return response.data;
  }
 } catch (error) {
  return error?.response?.data;
 }
};
export const deleteMultipleItem = async (url, ids, fetchDataCallback) => {
 try {
  const response = await axiosInstance.post(url, { ids });

  if (response.status === 200) {
   toast.success(response.data?.message || "Items deleted successfully.");
   if (fetchDataCallback) fetchDataCallback();
   return true;
  } else {
   toast.error(response.data?.message || "Failed to delete items.");
   return false;
  }
 } catch (error) {
  toast.error(
   error?.response?.data?.message || "Something went wrong. Please try again!!"
  );
  return false;
 }
};
export const toggleStatus = async (url, id) => {
 try {
  const response = await axiosInstance.get(`${url}/${id}`);
  if (response.status === 200) {
   toast.success(response.data?.message);
   return response.data?.data;
  }
 } catch (error) {
  toast.error(error.response?.data?.message || "An error occurred");
  return {};
 }
};
// export const handleDragEnd = async ({
//  result,
//  data,
//  setData,
//  apiEndpoint,
//  onSuccess,
//  onError,
// }) => {
//  if (!result.destination) return;

//  const reorderedItems = Array.from(data);
//  const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
//  reorderedItems.splice(result.destination.index, 0, reorderedItem);
//  const updatedData = reorderedItems.map((item, index) => ({
//   ...item,
//   position: index + 1,
//  }));

//  setData(updatedData);
//  const changedItems = updatedData.map((item) => ({
//   id: item.id,
//   position: item.position,
//  }));

//  try {
//   const response = await axiosInstance.post(apiEndpoint, {
//    data: changedItems,
//   });
//   if (response.data.isSuccess) {
//    toast.success(response.data.message);
//    if (onSuccess) onSuccess(response.data);
//   }
//  } catch (error) {
//   toast.error(error.response?.data?.message);
//   if (onError) onError(error);
//  }
// };
export const handleDragEnd = async ({
  result,
  data,
  setData,
  apiEndpoint,
  onSuccess,
  onError,
}) => {
  if (!result.destination) return;

  // 1️⃣ Store original DB positions
  const originalPositions = data
    .map(item => item.position)
    .sort((a, b) => a - b);

  // 2️⃣ Reorder items using drag index
  const reorderedItems = Array.from(data);
  const [movedItem] = reorderedItems.splice(result.source.index, 1);
  reorderedItems.splice(result.destination.index, 0, movedItem);

  // 3️⃣ Reassign ORIGINAL positions (not index)
  const updatedData = reorderedItems.map((item, index) => ({
    ...item,
    position: originalPositions[index],
  }));

  // 4️⃣ Update UI
  setData(updatedData);

  // 5️⃣ Correct payload (DB position)
  const changedItems = updatedData.map(item => ({
    id: item.id,
    position: item.position,
  }));

  try {
    const response = await axiosInstance.post(apiEndpoint, {
      data: changedItems,
    });

    if (response.data?.isSuccess) {
      toast.success(response.data.message);
      onSuccess?.(response.data);
    }
  } catch (error) {
    toast.error(error.response?.data?.message);
    onError?.(error);
  }
};

export const getFetchData = async ({ url, setGetData, body }) => {
 try {
  const response = await axiosInstance.get(`${url}`, { body });
  if (response.status === 200) {
   setGetData && setGetData(response.data?.data);
   return response.data?.data;
  }
 } catch (error) {
  toast.error(error.response?.data?.message || "An error occurred");
  return {};
 }
};
export const postfetchData = async (
 url,
 requestData,
 setData,
 setTotalCount,
 setCurrentPage,
 setIsLoading
) => {
 setIsLoading && setIsLoading(true);
 try {
  const response = await axiosInstance.post(url, requestData);
  const { data, totalCount } = response.data;
  setData(data);
  setTotalCount(totalCount);
  setCurrentPage(requestData.pageNo);
 } catch (error) {
  let message = error?.response?.data?.message || "Something went wrong";
  toast.error(message);
 } finally {
  setIsLoading && setIsLoading(false);
 }
};
export const getAttributes = async (categoryAttributes) => {
 try {
  if (!categoryAttributes || !Array.isArray(categoryAttributes)) return [];

  const allAttributes = await Promise.all(
   categoryAttributes.map(async (item) => {
    const id = item?.attribute?.id;
    if (!id) return null;

    const res = await axiosInstance.get(`/attribute-value/${id}`);
    if (res.status === 200) {
     const { data } = res?.data;
     const updatedData = data.map(({ attribute, ...rest }) => rest);

     return {
      id: data[0]?.attribute?.id,
      key: data[0]?.attribute?.key,
      name: data[0]?.attribute?.name,
      inputType: data[0]?.attribute?.inputType,
      children: updatedData,
     };
    }
    return null;
   })
  );

  return allAttributes.filter(Boolean); // remove nulls
 } catch (error) {
  throw error?.response?.message || "Failed to fetch attributes";
 }
};
